import { Theme, createStyles } from "@material-ui/core";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      "&$checked": {
        color: "#1D7DEA !important",
      },
      "& label.MuiFormLabel-root": {
        fontSize: "1rem",
        color: "#33333",
      },
      "& p, a": {
        color: "#33333",
        fontSize: "1rem",
      },
    },
    button: {
      margin: theme.spacing.unit,
    },
    doneBtn: {
      marginTop: 20,
    },
    mb1x: {
      margin: theme.spacing.unit,
    },
    formControllContainer: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
    },
    fontSizeLG: {
      fontSize: "1.75rem",
    },
    fontSizeMD: {
      fontSize: "1rem",
    },
    fontWeight500: {
      fontWeight: 500,
    },
    cardContainer: {
      border: "1px solid #E1E1E1",
      borderRadius: 4,
    },
    modal: {
      display: "flex",
      padding: 12,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 4,
    },
    paper: {
      width: 680,
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: "20, 40, 30",
      borderRadius: 4,
      outline: "#fff",
    },
    modalHeader: {
      height: 66,
      borderBottom: "1px solid #E2E2E2",
      background: "#fff",
      backgroundColor: "#fff",
    },
    mxWidth500: {
      maxWidth: 500,
    },
  });

export { styles };
